import * as React from "react";
import { Link } from "components/common";
import Routes from "routing/Routes";
import AppConfig from "util/AppConfig";
import HideOnCloud from "util/conditional/HideOnCloud";
import { NodesStore } from "stores/nodes/NodesStore";
import { useStore } from "stores/connect";
import Icon from "./Icon";
import Spinner from "./Spinner";
const LinkToNode = ({ nodeId }) => {
  const nodes = useStore(NodesStore, (state) => state == null ? void 0 : state.nodes);
  if (!nodes) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const node = nodes[nodeId];
  if (node) {
    const iconName = node.is_leader ? "star" : "fork_right";
    const iconClass = node.is_leader ? "leader-node" : "";
    const iconTitle = node.is_leader ? "This is the leader node in the cluster" : "";
    const content = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Icon, { name: iconName, className: iconClass, title: iconTitle }), " ", node.short_node_id, /* @__PURE__ */ React.createElement(HideOnCloud, null, " / ", node.hostname));
    if (AppConfig.isCloud()) {
      return content;
    }
    return /* @__PURE__ */ React.createElement(Link, { to: Routes.SYSTEM.CLUSTER.NODE_SHOW(nodeId) }, content);
  }
  return /* @__PURE__ */ React.createElement("i", null, "Unknown Node");
};
export default LinkToNode;
